import apiService from 'services/api'
import { CompanyFormShape, CompanyModal } from './CompanyModal'
import { toast } from 'react-toastify'
import React, { useState } from 'react'
import FbButton from '../../FbUI/FbButton'
import { FaPlus } from 'react-icons/fa'
import { IContactCompany } from '../../../models/contact_companies'
import { useQueryClient } from '@tanstack/react-query'

interface CreateDoorProxyModalProps {
  chainProxy?: IContactCompany
  unmatchedTableKey?: string
}

export function CreateDoorProxyModal({
  chainProxy,
  unmatchedTableKey,
}: CreateDoorProxyModalProps) {
  const [show, setShow] = useState(false)
  const api = apiService()
  const queryClient = useQueryClient()
  const { refetch } = api.useDoorProxiesOfChainProxy(chainProxy?.id)

  const apiAction = async (values: CompanyFormShape) => {
    const payload = {
      ...values,
      country: values.country || 'US',
      state: values.state || '',
      city: values.city || '',
      domain: values.domain?.toLowerCase() || '',
      name: values.name?.trim() || '',
      chain_proxy_id: chainProxy?.id,
      address: values.address || '',
      zipcode: values.zipcode || '',
    }

    try {
      const response = await api.createDoorProxy(payload)
      await refetch()

      // Invalidate the specific unmatched doors table if provided
      if (unmatchedTableKey) {
        queryClient.invalidateQueries({
          queryKey: [unmatchedTableKey],
        })
      }

      // Also invalidate the legacy pattern for backward compatibility
      if (chainProxy?.id) {
        queryClient.invalidateQueries({
          queryKey: [`UNMATCHED_DOORS_TABLE_FOR_CHAIN_PROXY_${chainProxy.id}`],
        })
      }

      toast.success('Door created successfully')
      setShow(false)
      return response
    } catch (error) {
      toast.error('Failed to create door')
      throw error
    }
  }

  return (
    <>
      <FbButton onClick={() => setShow(true)}>
        <FaPlus size={14} /> Add Door
      </FbButton>
      <CompanyModal
        defaultValues={{
          domain: chainProxy?.domain ?? '',
        }}
        hideCategoryAndType
        hideKnownDistributorsAndTags
        show={show}
        setShow={setShow}
        apiAction={apiAction}
        title="New Door"
        description="Add a company to First Bite to track additional deals and opportunities."
        acceptButtonText="Create Door"
      />
    </>
  )
}
